/**
 * Sets the visibility & scroll functionality of a return to top btn
 * Required DOM references (separate or combined element)
 * @button - [data-top-button]
 * @observer - [data-top-observer]
 * 
 */

import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin)

export default class ReturnToTopButton {
  constructor(els){
    this.button = document.querySelector('[data-top-button]')
    this.target = document.querySelector('[data-top-observer]')

    if (!this.button || !document.body.classList.contains('is-mobile')) return

    this.initEvents()
    this.createObserver()

    this.observerActive = true

  }
  initEvents() {
    // this.button = document.querySelector('[data-top-button]')

    if (this.button) {
      this.button.addEventListener("click", this.handleClick);
    }

  } 
  removeEvents() {
    if (this.button) {
      this.button.removeEventListener("click", this.handleClick);
    }
  }
  handleClick() {
    gsap
    .to(window, 1, {
      scrollTo: {
        y: 0,
        ease: "power2.inOut"
      }
    })
  }
  setVisibility(show) {
    if (show == true ) {
      gsap.to(this.button, 0.5, {
        autoAlpha: 1, 
        delay: 0.25,
        ease: "power2.Out",
      })
    } else {
      gsap.to(this.button, 0.25, {
        autoAlpha: 0, 
        ease: "power2.Out",
        overwrite: true
      })
    }
  }

  createObserver() {

    const options = {
      // rootMargin: '10px',
      threshold: 0
    }

    const callback = (entries) => {
      entries.forEach(entry => {

        if (entry.isIntersecting) {
          let elem = entry.target;

          if (entry.intersectionRatio >= 0) {
            this.setVisibility(true)
          }
        } else {
          this.setVisibility(false)
        }

      })
    }

    this.observer = new IntersectionObserver(callback, options)
    this.observer.observe(this.target)

  }
  destroyObserver() {
    if (this.observerActive) {
      this.observer.unobserve(this.target)
      this.observerActive = false
    }
  }
  destroy() {
    this.removeEvents()
    this.destroyObserver()
  }

}
